/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ServicedeskCmdbAssetsReportsUnsubscribe from '@jira/spa-apps__servicedesk-cmdb-assets-reports-unsubscribe/src/CmdbAssetsReportsUnsubscribe.tsx';
import type ServicedeskCmdbAssetsReports from '@jira/spa-apps__servicedesk-cmdb-assets-reports/src/CmdbAssetsReports.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbAssetsReports: LazyComponent<() => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof ServicedeskCmdbAssetsReports>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-assets-reports", jiraSpaEntry: "async-servicedesk-assets-reports" */ '@jira/spa-apps__servicedesk-cmdb-assets-reports/src/CmdbAssetsReports.tsx'
			).then((exportedMembers) => exportedMembers.CmdbAssetsReports),
		{ ssr: false },
	);

export const LazyServicedeskCmdbDefaultReportsRedirect: LazyComponent<() => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof ServicedeskCmdbAssetsReports>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-assets-reports-default-redirect", jiraSpaEntry: "async-servicedesk-assets-reports-default-redirect" */ '@jira/spa-apps__servicedesk-cmdb-assets-reports/src/CmdbAssetsReports.tsx'
			).then((exportedMembers) => exportedMembers.CmdbDefaultReportsRedirect),
		{ ssr: false },
	);

export const LazyServicedeskCmdbAssetsReportsUnsubscribe: LazyComponent<() => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof ServicedeskCmdbAssetsReportsUnsubscribe>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-assets-reports-unsubscribe", jiraSpaEntry: "async-servicedesk-assets-reports-unsubscribe" */ '@jira/spa-apps__servicedesk-cmdb-assets-reports-unsubscribe/src/CmdbAssetsReportsUnsubscribe.tsx'
			),
		{ ssr: false },
	);

export const LazyServicedeskCmdbAssetsReportsNav4HomePage: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskCmdbAssetsReports>(() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-assets-reports-home-page", jiraSpaEntry: "async-servicedesk-assets-reports-home-page" */ '@jira/spa-apps__servicedesk-cmdb-assets-reports/src/CmdbAssetsReports.tsx'
		).then((exportedMembers) => exportedMembers.CmdbAssetsReportsNav4HomePage),
	);

export const AssetsReports = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbAssetsReports}
		pageId="spa-apps/servicedesk/insight/cmdb-assets-reports"
		shouldShowSpinner
	/>
);

export const AssetsReportsUnsubscribe = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbAssetsReportsUnsubscribe}
		pageId="spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe"
		shouldShowSpinner
	/>
);

export const AssetsReportingDefaultRedirect = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbDefaultReportsRedirect}
		pageId="spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect"
		shouldShowSpinner
	/>
);

export const AssetsReportsNav4HomePage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbAssetsReportsNav4HomePage}
		pageId="spa-apps/servicedesk/insight/cmdb-assets-reports-home-page"
		shouldShowSpinner
	/>
);
